import React from 'react';

const Contact = (props) => (
	<svg id="ikony" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
		<g>
			<path
				  d="m11.01.5C5.2.5.51,5.2.51,11c0,1.91.51,3.71,1.41,5.25.09.16.19.31.29.47l.02.02c.39.6.84,1.16,1.34,1.67.18.18.37.36.56.51.1.09.2.17.31.25,1.79,1.47,4.07,2.33,6.57,2.33,1.8,0,3.5-.45,4.99-1.27v-1.16c-1.45.91-3.16,1.43-5,1.43-5.25,0-9.5-4.26-9.5-9.5S5.75,1.5,11,1.5s9.5,4.25,9.5,9.5c0,1.23-.16,2.44-.66,3.49-.31.65-1.04,1.05-1.79,1.05-1.13,0-2.05-.93-2.05-2.06v-2.48c0-.36-.04-.71-.11-1.04-.48-2.27-2.49-3.96-4.89-3.96-2.76,0-5,2.23-5,5s2.24,5,5,5c1.66,0,3.13-.81,4.04-2.06.22,1.47,1.49,2.6,3.01,2.6.25,0,.49-.03.73-.09.83-.21,1.59-.75,1.96-1.53.09-.2.16-.4.22-.6.35-1.05.54-2.16.54-3.32C21.5,5.2,16.8.5,11.01.5Zm-.01,12.5c-1.11,0-2-.9-2-2s.89-2,2-2,2,.89,2,2-.9,2-2,2Z"/>
		</g>
	</svg>
);

export default Contact;